// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Фінанси партії» (Party Finance, ключ `fin`, група `party-and-group`). */
export const partyFinanceManifest: IModuleManifest = {
  key: 'fin',
  group: 'party-and-group',
  slug: 'party-finance',
  prefix: 'FIN',
  name: { en: 'Party Finance', uk: 'Фінанси партії' },
  entities: [
    { key: 'fin', slug: 'fin', name: { en: 'Party Finance', uk: 'Фінанси партії' }, main: true },
    { key: 'donation_expense', slug: 'donation-expense', name: { en: 'Donation Expenses', uk: 'Видатки' }, main: false },
    { key: 'donation_report', slug: 'donation-report', name: { en: 'Donation Reports', uk: 'Звіти' }, main: false },
    { key: 'donation_donor', slug: 'donation-donor', name: { en: 'Donation Donors', uk: 'Донори' }, main: false },
  ],
  loadState: () => import('./state/partyFinanceSlice').then((m) => m.partyFinanceSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
